import {observer} from "mobx-react-lite";
import React, {Fragment, useEffect} from "react";
import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Row, Select,
    Space,
    Table,
} from "antd";
import Update from "./update";
import {CommonStore, RecordingManageStore} from "../../store";
import dictionary from "../../utils/dictionary";
import dayjs from "dayjs";

const {Column} = Table;
const {RangePicker} = DatePicker;

function RecordingManage() {
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue({
            sessionId: '',
            platformId: null,
            type: null,
            cdrCallerNumber: '',
            cdrCalledNumber: '',
            cdrServiceNumber: '',
            cdrDisplayNumber: '',
            time: [dayjs(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss")), dayjs(dayjs().format("YYYY-MM-DD HH:mm:ss")),],
        });
        CommonStore.getPlatformCode();
        resetSearchbth();
    }, []);
    const searchBtn = () => {
        RecordingManageStore.resetPage();
        RecordingManageStore.getRecordingPage();
    };
    const resetSearchbth = () => {
        RecordingManageStore.setSearchForm({time: [dayjs(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss")), dayjs(dayjs().format("YYYY-MM-DD HH:mm:ss"))]});
        searchBtn();
    };
    const getFormData = (
        changeValue: powerSearchData,
        allValues: powerSearchData
    ) => {
        RecordingManageStore.setSearchForm({...allValues});
    };
    return (
        <Fragment>
            <Update></Update>
            <div className="formContent">
                <Form
                    form={form}
                    initialValues={RecordingManageStore.searchForm}
                    autoComplete="off"
                    labelCol={{span: 6}}
                    onValuesChange={getFormData}
                >
                    <Row justify="start">
                        <Col span={8}>
                            <Form.Item label="通话ID" name="sessionId">
                                <Input placeholder="请输入通话ID"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="平台编码" name="platformId">
                                {/*<Input placeholder="请输入通话平台"/>*/}
                                <Select
                                    allowClear
                                    placeholder="请选择平台编码"
                                    options={CommonStore.targetPlatformList.map(item => ({ label: item.value, value: item.value }))}
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="录音类型" name="type">
                                <Select options={dictionary.recordingType} allowClear placeholder='请选择录音类型'/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="主叫号码" name="cdrCallerNumber">
                                <Input placeholder="请输入主叫号码"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="被叫号码" name="cdrCalledNumber">
                                <Input placeholder="请输入被叫号码"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="中间号" name="cdrServiceNumber">
                                <Input placeholder="请输入中间号"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="外显号码" name="cdrDisplayNumber">
                                <Input placeholder="请输入外显号码"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="呼叫时间" name="time">
                                <RangePicker
                                    showTime
                                    style={{width: "100%"}}
                                    format="YYYY-MM-DD HH:mm:ss"
                                    placeholder={["开始时间", "结束时间"]}
                                />
                            </Form.Item>
                        </Col>
                        <Col offset={2}>
                            <Space>
                                <Button type="primary" onClick={searchBtn}>
                                    搜索
                                </Button>
                                <Button htmlType="reset" onClick={resetSearchbth}>
                                    重置
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                    <Row>
                        {(CommonStore.pagePermission.writable ||
                            CommonStore.pagePermission.manageable) &&<Col span={8} offset={16}>
                            <Button
                                type="primary"
                                style={{float: "right", marginBottom: "10px"}}
                                onClick={() => RecordingManageStore.addOrUpdateModal.open('configuration')}
                            >
                                录音设置
                            </Button>
                        </Col>}
                    </Row>
                </Form>
            </div>
            <Table
                dataSource={RecordingManageStore.tableData.records}
                rowKey={(record: { sessionId: string }) => record.sessionId}
                loading={RecordingManageStore.tableLoad}
                scroll={{x: 2500}}
                pagination={{
                    current: RecordingManageStore.pageData.page,
                    pageSize: RecordingManageStore.pageData.size,
                    onChange: RecordingManageStore.pageData.changePage,
                    pageSizeOptions: [10, 25, 50],
                    showSizeChanger: true,
                    total: RecordingManageStore.tableData.total,
                    showTotal: () => `共计${RecordingManageStore.tableData.total}条`,
                    position: ["bottomLeft"],
                }}
            >
                <Column
                    title="通话ID"
                    ellipsis={true}
                    dataIndex="sessionId"
                />
                <Column
                    ellipsis={true}
                    title="平台编码"
                    dataIndex="platformId"
                />
                {/*<Column*/}
                {/*    ellipsis={true}*/}
                {/*    title="录音文件名"*/}
                {/*    dataIndex="objectNames"*/}
                {/*/>*/}
                {/*<Column*/}
                {/*    ellipsis={true}*/}
                {/*    title="文件类型"*/}
                {/*    dataIndex="filenameExtension"*/}
                {/*/>*/}
                <Column
                    ellipsis={true}
                    title="文件大小(M)"
                    dataIndex="size"
                    render={(size) => (size/1024/1024).toFixed(2)}
                />
                <Column
                    ellipsis={true}
                    title="录音文件类型"
                    dataIndex="type"
                    render={(type) =>
                        dictionary.recordingType.find(
                            (item: any) => item.value == type
                        )?.label
                    }
                />
                <Column
                    ellipsis={true}
                    title="下载任务实例名称"
                    dataIndex="taskInstance"
                />
                <Column
                    ellipsis={true}
                    title="主叫号码"
                    dataIndex="cdrCallerNumber"
                />
                <Column
                    ellipsis={true}
                    title="被叫号码"
                    dataIndex="cdrCalledNumber"
                />
                <Column
                    ellipsis={true}
                    title="中间号"
                    dataIndex="cdrServiceNumber"
                />
                <Column
                    ellipsis={true}
                    title="外显号码"
                    dataIndex="cdrDisplayNumber"
                />
                <Column
                    ellipsis={true}
                    title="呼叫时间"
                    dataIndex="cdrDialTime"
                />
                <Column
                    ellipsis={true}
                    title="振铃时间"
                    dataIndex="cdrRingTime"
                />
                <Column
                    ellipsis={true}
                    title="接通时间"
                    dataIndex="cdrAnswerTime"
                />
                <Column
                    ellipsis={true}
                    title="挂断时间"
                    dataIndex="cdrEndTime"
                />
                <Column
                    ellipsis={true}
                    title="话单日期"
                    dataIndex="cdrDate"
                />
                <Column
                    width={120}
                    fixed={"right"}
                    render={(text: string, record: any) => (
                        <Space>
                            <Button
                                size={"small"}
                                onClick={() => RecordingManageStore.confirmDownload(record?.objectNames)}
                            >
                                下载录音
                            </Button>
                        </Space>
                    )}
                />
            </Table>
        </Fragment>
    );
}

export default observer(RecordingManage);
